import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../helpers/saga';
import { logger } from '../../../helpers/logger';
import notifications from '../../../redux/notifications/actions';
import Api from '../../../helpers/api';
import { t } from '../../../i18n';
import { keyByProperty } from '../../../helpers/core';

const api = new Api('reasons');
const feedbackApi = new Api('reasons/:id');

function* loadData() {
  try {
    const result = yield call(sendRequest, api.load, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(
        actions.loadDataSuccess({
          data,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* deleteClient(data) {
  try {
    const { payload } = data;
    const { id } = payload;

    const result = yield call(sendRequest, feedbackApi.deleteItem, { id }, notifications.REQUEST_ERROR);

    if (result && result.data) {
      yield loadData();
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.deleted_successfully', {
            item: t('dash.admin.clientFeedbackOptions.option'),
          }),
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* save(data) {
  try {
    const { payload } = data;
    const { editForm, id } = payload;
    const { usableBy, reasonType } = editForm;
    const propsArray = Object.values(editForm);
    const feedback = keyByProperty(propsArray, 'name', prop => prop.value);
    const result = yield call(
      sendRequest,
      api.updateItem,
      {
        data: {
          reason: {
            text: feedback.text,
            reason_type: reasonType,
            usable_by: usableBy,
          },
        },
        id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      const response = {
        positive: loadData(),
        negative: loadData(),
        reporting: loadData(),
      };

      yield response[reasonType];

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: 'Option updated successfully',
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

function* add(data) {
  try {
    const { payload } = data;
    const { editForm, usableBy, reasonType } = payload;
    const propsArray = Object.values(editForm);
    const feedback = keyByProperty(propsArray, 'name', prop => prop.value);
    const result = yield call(
      sendRequest,
      feedbackApi.createItem,
      {
        data: {
          reason: {
            text: feedback.text,
            reason_type: reasonType,
            usable_by: usableBy,
          },
        },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const response = {
        positive: loadData(),
        negative: loadData(),
      };

      yield response[reasonType];

      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: 'Option created successfully',
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.DELETE, deleteClient),
    takeEvery(actions.SAVE, save),
    takeEvery(actions.ADD, add),
  ]);
}
